document.addEventListener("click", function (e) {
  const swatch = e.target.closest(".swatch");
  if (!swatch) return;
 
  const cardContainer = swatch.closest(".card-product-container");
  const productId = swatch.dataset.productId;
  const swatchUrl = swatch.dataset.url;
 
  if (!cardContainer || !swatchUrl) return;
  if (swatch.classList.contains("loading")) return;
  swatch.classList.add("loading");
 
  let fetchUrl = swatchUrl;
  fetchUrl += (swatchUrl.includes("?") ? "&" : "?") + "section_id=product-card-ajax";
 
  fetch(fetchUrl)
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const newDoc = parser.parseFromString(html, "text/html");
 
      let newCard = newDoc.querySelector(`#card-product-${productId}`);
 
      if (!newCard) {
        newCard = newDoc.querySelector(".card-product-container");
      }
 
      if (newCard) {
        cardContainer.replaceWith(newCard);
      } else {
        console.warn("No replacement card found for product", productId);
      }
    })
    .catch(err => {
      console.error("Swatch fetch error:", err);
    })
    .finally(() => {
      swatch.classList.remove("loading");
    });
});